export enum MonitorMenuDialogDessagesEnum {
    MonitorRenamedTitle = 'Monitor title was successfully renamed',
    MonitorRenamedDescription = 'New monitor title is:',

    AssignmentUnsuccessfulDescription = 'You can not assign a local playlist to the other location',
    AssignmentAndroidPlaylistToWindowsLocationUnsuccessfulDescription = 'You can not assign an Android playlist to the Windows location',
    AssignmentWindowsPlaylistToAndroidLocationUnsuccessfulDescription = 'You can not assign a Windows playlist to the Android location',

    FullScreenViewTitle = 'Fullscreen view',
    LinkCopiedToClipboardDescription = 'The link has been copied to your clipboard',

    MonitorUpdateSuccessTitle = 'Update success',
    MonitorsStartOptionUpdatedDescription = 'Start options for selected monitors successfully updated'
}
